import React, { useState, useRef, useEffect } from 'react';
import styles from 'styles/drag_and_drop.module.scss';

const DragAndDrop = props => {
	const { noClass, className, children } = props
	const [state, setState] = useState({ drag: false });
	const dropRef = useRef(null);

	const handleDrag = e => {
		e.preventDefault();
		// e.stopPropagation();
	};

	const handleDragIn = e => {
		e.preventDefault();
		// e.stopPropagation();
		if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
			setState({ drag: true });
		}
	};

	const handleDragOut = e => {
		e.preventDefault();
		// e.stopPropagation();
		setState({ drag: false });
	};

	const handleDrop = e => {
		e.preventDefault();
		// e.stopPropagation();
		setState({ drag: false });
		if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
			props.handleDrop(e.dataTransfer.files);
			e.dataTransfer.clearData();
		}
	};

	useEffect(() => {
		let div = dropRef.current;
		div.addEventListener('dragenter', handleDragIn);
		div.addEventListener('dragleave', handleDragOut);
		div.addEventListener('dragover', handleDrag);
		div.addEventListener('drop', handleDrop);
		return () => {
			let div = dropRef.current;
			div.removeEventListener('dragenter', handleDragIn);
			div.removeEventListener('dragleave', handleDragOut);
			div.removeEventListener('dragover', handleDrag);
			div.removeEventListener('drop', handleDrop);
		};
	}, []);

	return (
		<div ref={dropRef} className={noClass || className ? className : `${styles.dragAndDrop} ${state.drag ? styles.dragging : ''}`}>
			{children}
		</div>
	);
};

export default DragAndDrop;
